import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { DeleteAccountModalContent } from './DeleteAccountModalContent'
import * as deleteUserActionCreators from '../../redux/css-admin/deleteUser/operations'

const mapStateToProps = ({ userManager }) => ({ ...userManager })
const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      ...deleteUserActionCreators,
    },
    dispatch,
  )
}

const DeleteAccountModalContentContainerBase = ({
  productUser,
  HandleDeleteUser,
  onCloseModal,
}) => {
  const [checked, setChecked] = useState(false)
  const onCheck = event => {
    setChecked(event.target.checked)
  }
  const onDeleteAccount = async () => {
    onCloseModal()
    HandleDeleteUser({ userEmail: productUser.email })
  }

  return (
    <React.Fragment>
      <DeleteAccountModalContent
        checked={checked}
        clientEmail={productUser.email}
        onCheck={onCheck}
        onCloseModal={onCloseModal}
        onDeleteAccount={onDeleteAccount}
      />
    </React.Fragment>
  )
}

DeleteAccountModalContentContainerBase.propTypes = {
  HandleDeleteUser: PropTypes.func,
  onCloseModal: PropTypes.func,
  productUser: PropTypes.shape({ email: PropTypes.string }).isRequired,
}

export const DeleteAccountModalContentContainer = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DeleteAccountModalContentContainerBase)



// WEBPACK FOOTER //
// ./src/components/DeleteAccountModalContent/DeleteAccountModalContentContainer.js